<template>
  <div class="soha-progress-circle">
    <svg viewBox="0 0 100 100">
      <circle
        class="soha-circle-background"
        :stroke-dasharray="0"
        :stroke-dashoffset="dashoffset"
        :r="radius"
        cx="50"
        cy="50"
        fill="transparent"
      />
      <circle
        class="soha-circle-value"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashoffset"
        :r="radius"
        cx="50"
        cy="50"
        fill="transparent"
      />

      <text
        v-if="label"
        x="79"
        y="55"
        font-size="12"
        font-weight="bold"
        fill="var(--muted-color)"
      >
        {{ label }}
      </text>
      <text
        v-if="!label"
        x="60%"
        y="40"
        font-size="16"
        font-weight="bold"
        fill="var(--secondary-color)"
      >
        {{ toPersianDigits(count) }}
      </text>
      <line
        v-if="!label"
        x1="35%"
        y1="50%"
        x2="65%"
        y2="50%"
        stroke="var(--box-border-color)"
      />
      <text
        v-if="!label"
        x="60%"
        y="70"
        font-size="16"
        font-weight="bold"
        fill="var(--muted-color)"
      >
        {{ toPersianDigits(max) }}
      </text>
    </svg>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";

export default {
  name: "CircleProgress",
  mixins: [UIMixin],
  props: {
    count: {
      require: true,
      type: Number,
      default: 50,
    },
    max: {
      require: true,
      type: Number,
      default: 100,
    },
    label: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      radius: 45,
      circumference: 2 * Math.PI * 45,
      value: (this.count / this.max) * 100,
    };
  },
  computed: {
    dashoffset() {
      return (this.circumference * (100 - this.value)) / 100;
    },
  },
};
</script>

<style scoped>
.soha-progress-circle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 15.385rem;
  margin: auto;
}
.soha-circle-value {
  stroke: var(--secondary-color);
  stroke-width: 8;
  transition: stroke-dashoffset 0.5s ease-in-out;
  transform: rotate(-90deg);
  transform-origin: center;
  border-radius: 0.385rem;
}

.soha-circle-background {
  stroke: var(--muted-background-color);
  stroke-width: 8;
  transition: stroke-dashoffset 0.5s ease-in-out;
  transform: rotate(-90deg);
  transform-origin: center;
}
</style>
